module.exports = __webpack_public_path__ + "img/loginpage_bg.08aec602.jpg";